import UAParser from "ua-parser-js"

/**
 * Преобразует строку User-Agent в человекочитаемый вид для отображения пользователю
 * @param userAgent
 * @returns строка вида "<ОС> / <Браузер или приложение>", например: "Windows 10 / Chrome 116.0" или "iOS 16.5 / Мобильное приложение"
 */
export function formatUserAgent(userAgent: string) {
	const parsedUA = new UAParser(userAgent).getResult()

	const os = parsedUA.os.name ? `${parsedUA.os.name} ${parsedUA.os.version}` : parsedUA.ua
	let browser = parsedUA.browser.name ? `${parsedUA.browser.name} ${parsedUA.browser.version}` : ""

	if (browser.includes("kemsuMobile") || parsedUA.ua.includes("kemsuMobile")) {
		browser = "Мобильное приложение"
	}

	return `${os}${browser ? ` / ${browser}` : ""}`
}